const toQueryString = obj =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    if (typeof value === 'undefined' || value === null) {
      return acc;
    }
    const encodedValue = Array.isArray(value)
      ? value.map(v => encodeURIComponent(String(v))).join(',')
      : encodeURIComponent(String(value));
    return `${acc + (acc ? '&' : '?')}${encodeURIComponent(key)}=${encodedValue}`;
  }, '');

export default toQueryString;
